<ng-container>
    <div class="overlay-warp">
        <div class="itemx" *ngFor="let item of statusList">
            <div [ngSwitch]="item.status">
                <div class="item-list">
                    <div class="choose" [ngClass]="{'selected': item.choosed}" (click)="selectStatus(item)">
                        <div class="inner-selected">
                            <img src="/assets/images/auto-fill/vi.svg">
                        </div>
                    </div>
                    <div *ngSwitchCase="enumReplyStatus.Approved" class="st approvaled">
                        <p translate>column.reports.formStatusValue.approved</p>
                    </div>
                    <div *ngSwitchCase="enumReplyStatus.PendingApproval" class="st pending-approval">
                        <p translate>column.reports.formStatusValue.pending</p>
                    </div>
                    <div *ngSwitchCase="enumReplyStatus.Rejected" class="st rejected">
                        <p translate>column.reports.formStatusValue.rejected</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
